import { ResetPasswordComponent } from './resetPassword/resetPassword.component';
import { CancelPageComponent } from './claimprocess/cancelPage.component';
import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core';


import { ClaimProcessComponent } from './claimprocess/claimProcess.component'
import { LoginClaimProcessComponent } from './claimprocess/loginClaimProcess.component';
import { SecurityQuestionListComponent } from './claimprocess/securityQuestions.component';
import { SetUpPasswordComponent } from './claimprocess/setUpPassword.component';
import { SuccessComponent } from './claimprocess/success.component';
import { ForgotPasswordComponent } from './resetPassword/forgotPassword.component';
import { CancelPageForgotPasswordComponent } from './resetPassword/forgotPasswordCancelPage.component';
import { AuthForcedLoginGuard } from '@wgu-edu/wgu-core';
import { SuccessResetComponent } from './resetPassword/success.component';
import { LandingPageComponent } from './landingPage/landingPage.component';
import { UpdateAccountComponent } from './updateAccount/updateAccount.component';
import { UsernameAccount } from './updateAccount/usernameAccount.component';
import { CancelPageAnswerQuestionsComponent } from './resetPassword/answerQuestionsCancelPage.component';

import { isPolicyAcknowledgeGuard } from './guards/policyAcknowledgement.guard';
import { ValidateSecurityQuestions } from './resetPassword/validateQuestions.component';


const appRoutes:Routes = [
  { path: '', component: LandingPageComponent, pathMatch: 'full' },
  { path: 'identityiq/external/claimProcess', component: ClaimProcessComponent },
  { path: 'identityiq/external/loginClaimProcess', canMatch: [isPolicyAcknowledgeGuard], component: LoginClaimProcessComponent },
  { path: 'identityiq/external/loginClaimProcess', component: LandingPageComponent },
  { path: 'identityiq/external/securityQuestions', canMatch: [isPolicyAcknowledgeGuard], component: SecurityQuestionListComponent },
  { path: 'identityiq/external/securityQuestions', component: LandingPageComponent },
  { path: 'identityiq/external/setPassword', canMatch: [isPolicyAcknowledgeGuard], component: SetUpPasswordComponent },
  { path: 'identityiq/external/setPassword', component: LandingPageComponent },
  { path: 'identityiq/external/cancelPage', component: CancelPageComponent },
  { path: 'identityiq/external/success', component: SuccessComponent },
  { path: 'updateAccount', canActivate: [AuthForcedLoginGuard], component: UpdateAccountComponent},
  { path: 'identityiq/updateAccount', component: UsernameAccount },
  { path: 'identityiq/updateAccount/cancelPage', component:  CancelPageAnswerQuestionsComponent},
  { path: 'identityiq/external/forgotPassword/forgotPassword', component: ForgotPasswordComponent },
  { path: 'identityiq/external/forgotPassword/cancelPage', component:  CancelPageForgotPasswordComponent},
  { path: 'identityiq/external/forgotPassword/answerQuestions', component: ValidateSecurityQuestions},
  { path: 'identityiq/external/forgotPassword/resetPassword', component: ResetPasswordComponent },
  { path: 'identityiq/external/forgotPassword/success', component: SuccessResetComponent },

]

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})

export class AppRoutingModule {}